import { PaymentMethodsCustomerBankAccountSepaType } from "@oysterhr/schema"
import { Alert, Button, Modal, Text, Toast, useToast } from "@oysterhr/ui"
import { Trans, useTranslation } from "react-i18next"
import { useResendMandate } from "../sepa/hooks/useResendMandate"

type ResendMandateProps = {
  customerBankAccount: PaymentMethodsCustomerBankAccountSepaType | undefined
  onClose: () => void
  isOpen: boolean
}

export function ResendMandateModal({
  onClose,
  customerBankAccount,
  isOpen,
}: Readonly<ResendMandateProps>) {
  const toast = useToast()
  const [t] = useTranslation("company_interface/CompanyPaymentMethodsPage/ResendMandateModal")
  const [resendMandate, { loading: isResending }] = useResendMandate()

  if (customerBankAccount == null) return null

  const onResend = () => {
    resendMandate({
      variables: {
        mandateId: customerBankAccount.mandate?.id as string,
      },
      onCompleted: data => {
        if (data.sendMandateReminder.errors.length) {
          toast({
            render: (
              <Toast variation="error">
                <Toast.Content>{data.sendMandateReminder.errors.join(", ")}</Toast.Content>
              </Toast>
            ),
          })
        } else {
          toast({
            render: (
              <Toast variation="success">
                <Toast.Title>{t("toast.title")}</Toast.Title>
                <Toast.Content>{t("toast.content")}</Toast.Content>
              </Toast>
            ),
          })
          onClose()
        }
      },
    })
  }

  return (
    <Modal onRequestClose={onClose} isOpen={isOpen}>
      <Modal.Header>{t("title")}</Modal.Header>
      <Modal.Content>
        <div className="flex flex-col gap-4">
          <Text>
            <Trans
              defaults={t("content.description", { email: customerBankAccount.email })}
              components={{ b: <Text as="span" className="font-semibold" /> }}
            />
          </Text>

          <Alert variation="info">
            <Alert.Icon />
            <Alert.Content>{t("content.note")}</Alert.Content>
          </Alert>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <Button variation="secondary" onClick={onClose}>
          {t("cancel")}
        </Button>
        <Button variation="primary" onClick={onResend} isLoading={isResending}>
          {t("resendEmail")}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
